'use strict';

function OverbookingManagementDataService(dataRetriever, Transformer) {
  function getData(selectedFlights) {
    var transformer = new Transformer();
    return dataRetriever.getOverbookingManagementData(selectedFlights).then(function (retrieverResponse) {
      return transformer.transform({
        domain: retrieverResponse
      }, true);
    });
  }
  return {
    getData: getData
  };
}
OverbookingManagementDataService.$inject = ['FlightManagementDataRetrieverService', 'FlightCabinGridTransformerFactory'];
module.exports = OverbookingManagementDataService;